import { Modal } from "bootstrap";
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";

const EditB2BLeadModal = forwardRef((props, ref) => {

    const {
        getLeadData,
        selectedLeads,
        leadData,
    } = props;

    const modalRef = useRef(null);

    const bsModal = useRef(null);



    const [leadSourceOptions, setLeadSourceOptions] = useState([]);

    const [leadPipelineOptions, setLeadPipelineOptions] = useState([]);

    const [businessCategoryOptions, setBusinessCategoryOptions] = useState([]);

    const [shippingPartnerOptions, setShippingPartnerOptions] = useState([]);

    const [shipmentPotentialOptions, setShipmentPotentialOptions] = useState([]);

    const [clientPersonaOptions, setClientPersonaOptions] = useState([]);

    const [stateOptions, setStateOptions] = useState([]);
    const [editLeadData, setEditLeadData] = useState(null);



    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        mode: "onSubmit",
    });



    useImperativeHandle(ref, () => ({

        toggle(leadData) {


            if (!bsModal.current) {

                bsModal.current =
                    new Modal(modalRef.current);

            }
            setEditLeadData(leadData);

            // DEFAULT VALUES SET

            //           console.log(
            //     "SELECTED LEAD DATA",
            //      leadData
            // );
            if (leadData) {

                reset({

                    leadSource:
                        leadData?.leadSource
                            ? {
                                label:
                                    leadData?.leadSource,
                                value:
                                    leadData?.leadSource,
                            }
                            : null,

                    leadPipeline:
                        leadData?.leadPipeline
                            ? {
                                label:
                                    leadData?.leadPipeline,
                                value:
                                    leadData?.leadPipeline,
                            }
                            : null,

                    businessCategory:
                        leadData?.businessCategory
                            ? {
                                label:
                                    leadData?.businessCategory,
                                value:
                                    leadData?.businessCategory,
                            }
                            : null,

                    currentShippingPartner:
                        leadData?.currentShippingPartner
                            ? {
                                label:
                                    leadData?.currentShippingPartner,
                                value:
                                    leadData?.currentShippingPartner,
                            }
                            : null,

                    shipmentPotential:
                        leadData?.shipmentPotential
                            ? {
                                label:
                                    leadData?.shipmentPotential,
                                value:
                                    leadData?.shipmentPotential,
                            }
                            : null,

                    clientPersona:
                        leadData?.clientPersona
                            ? {
                                label:
                                    leadData?.clientPersona,
                                value:
                                    leadData?.clientPersona,
                            }
                            : null,

                    state:
                        leadData?.state
                            ? {
                                label:
                                    leadData?.state,
                                value:
                                    leadData?.state,
                            }
                            : null,

                    primaryContactName:
                        leadData?.primaryContactName || "",

                    primaryContactDesignation:
                        leadData?.primaryContactDesignation || "",

                    mobileNumber:
                        leadData?.mobileNumber || "",

                    companyName:
                        leadData?.companyName || "",

                    emailId:
                        leadData?.emailId || "",

                    minimumExpectedShipmentToFship:
                        leadData?.minimumExpectedShipmentToFship || "",

                    utmSource:
                        leadData?.utmSource || "",

                    utmMedium:
                        leadData?.utmMedium || "",

                    utmCampaign:
                        leadData?.utmCampaign || "",

                    utmTerm:
                        leadData?.utmTerm || "",

                    utmContent:
                        leadData?.utmContent || "",
                    accountType: leadData?.accountType || "",
                    accountType: leadData?.accountType
                        ? {
                            label: leadData?.accountType,
                            value: leadData?.accountType,
                        }
                        : null,

                });

            }

            bsModal.current.show();

        },

        close() {

            reset();

            bsModal.current?.hide();

        },

    }));

    const handleClose = () => {

        reset();

        bsModal.current?.hide();

    };

    // =========================
    // SUBMIT
    // =========================

    const onSubmit = async (data) => {

        try {

            const formData = new FormData();

            const payload = {

                ...data,

                leadSource: data?.leadSource?.value || "",

                leadPipeline: data?.leadPipeline?.value || "",


                businessCategory: data?.businessCategory?.value || "",

                currentShippingPartner: data?.currentShippingPartner?.value || "",

                shipmentPotential: data?.shipmentPotential?.value || "",

                clientPersona: data?.clientPersona?.value || "",

                state: data?.state?.value || "",
                accountType: data?.accountType?.value || "",

            };

            Object.keys(payload).forEach((key) => {

                formData.append(
                    key,
                    payload[key] ?? ""
                );

            });



            const res =
                await b2bleadService.updateLead(
                    editLeadData?.id,
                    formData
                );

            if (
                res?.data?.status === "error"
            ) {

                throw new Error(
                    res?.data?.message
                );

            }

            toast.success(
                res?.data?.message ||
                "Lead Updated Successfully"
            );

            reset();

            bsModal.current?.hide();

            getLeadData();

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong"
            );

        }

    };

    // =========================
    // INITIAL API CALLS
    // =========================

    useEffect(() => {

        getLeadSource();

        getleadpipelineoptions();

        getbusinessCategory();

        getshippingParnter();

        getshipmentPotenical();

        getclientpersona();

        getStates();

    }, []);

    // =========================
    // GET LEAD SOURCE
    // =========================

    const getLeadSource = () => {

        b2bleadService
            .leadSource()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setLeadSourceOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET PIPELINE
    // =========================

    const getleadpipelineoptions = () => {

        b2bleadService
            .leadpipelineoptions()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setLeadPipelineOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET BUSINESS CATEGORY
    // =========================

    const getbusinessCategory = () => {

        b2bleadService
            .businessCategory()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setBusinessCategoryOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET SHIPPING PARTNER
    // =========================

    const getshippingParnter = () => {

        b2bleadService
            .shippingPartner()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setShippingPartnerOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET SHIPMENT POTENTIAL
    // =========================

    const getshipmentPotenical = () => {

        b2bleadService
            .shipmentpotencialOptions()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setShipmentPotentialOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET CLIENT PERSONA
    // =========================

    const getclientpersona = () => {

        b2bleadService
            .clientPersona()
            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setClientPersonaOptions(
                    formattedOptions
                );

            });

    };

    // =========================
    // GET STATES
    // =========================

    const getStates = async () => {

        try {

            const res =
                await b2bleadService.getAllStates();

            const data =
                res?.data?.data || [];

            const formattedStates =
                data.map((item) => ({

                    label: item.name,

                    value: item.name,

                }));

            setStateOptions(
                formattedStates
            );

        } catch (error) {

            // console.log(
            //     "STATE ERROR",
            //     error
            // );

        }

    };

    return (

        <div
            className="modal"
            ref={modalRef}
            tabIndex="-1"
            aria-hidden="true"
            style={{
                background:
                    "rgba(15,23,42,0.55)",
                backdropFilter:
                    "blur(5px)",
            }}
        >

            <div
                className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                style={{
                    maxWidth: "1350px",
                }}
            >

                <div
                    className="modal-content border-0 shadow"
                    style={{
                        borderRadius: "18px",
                    }}
                >

                    <div
                        className="modal-header border-0 text-white"
                        style={{
                            borderBottom:
                                "1px solid #f1f1f1",
                            background:
                                "linear-gradient(135deg,#2563eb,#1d4ed8)",
                        }}
                    >

                        <p className="mb-0 small opacity-75">
                            Update Lead
                        </p>

                        <button
                            type="button"
                            className="btn btn-light rounded-circle position-absolute"
                            style={{
                                top: "10px",
                                right: "18px",
                                width: "38px",
                                height: "38px",
                            }}
                            onClick={handleClose}
                        >
                            <i className="fa fa-times"></i>
                        </button>

                    </div>

                    <div className="modal-body p-4">

                        <form
                            onSubmit={handleSubmit(onSubmit)}
                        >

                            <div className="row g-4">

                                {/* LEAD SOURCE */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Lead Source
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <Controller
                                        name="leadSource"
                                        control={control}
                                        rules={{
                                            required:
                                                "Lead Source is required",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                // isMulti
                                                classNamePrefix="react-select"
                                                options={leadSourceOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || []}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}
                                            />
                                        )}
                                    />

                                    {errors.leadSource && (
                                        <small className="text-danger">
                                            {
                                                errors
                                                    .leadSource
                                                    .message
                                            }
                                        </small>
                                    )}

                                </div>

                                {/* LEAD PIPELINE */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Lead Pipeline
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <Controller
                                        name="leadPipeline"
                                        control={control}
                                        rules={{
                                            required:
                                                "Lead Pipeline is required",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                // isMulti
                                                classNamePrefix="react-select"
                                                options={leadPipelineOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || []}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}

                                            />

                                        )}
                                    />

                                    {errors.leadPipeline && (
                                        <small className="text-danger">
                                            {
                                                errors
                                                    .leadPipeline
                                                    .message
                                            }
                                        </small>
                                    )}

                                </div>

                                {/* CONTACT NAME */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Primary Contact
                                        Name
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.primaryContactName
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Enter"
                                        {...register(
                                            "primaryContactName",
                                            {
                                                required:
                                                    "Primary Contact Name is required",
                                            }
                                        )}
                                    />

                                    {errors.primaryContactName && (
                                        <div className="invalid-feedback">
                                            {
                                                errors
                                                    .primaryContactName
                                                    .message
                                            }
                                        </div>
                                    )}

                                </div>

                                {/* DESIGNATION */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Primary Contact Designation 
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.primaryContactDesignation
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Enter"
                                        {...register(
                                            "primaryContactDesignation",
                                            // {
                                            //     required:
                                            //         "Primary Contact is required",
                                            // }
                                        )}
                                    />

                                    {/* {errors.primaryContactDesignation && (
                                        <div className="invalid-feedback">
                                            {
                                                errors
                                                    .primaryContactDesignation
                                                    .message
                                            }
                                        </div>
                                    )} */}


                                </div>

                                {/* MOBILE */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Mobile Number
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.mobileNumber
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Enter"
                                        {...register(
                                            "mobileNumber",
                                            {
                                                required:
                                                    "Mobile Number is required",
                                                pattern:
                                                {
                                                    value:
                                                        /^[0-9]{10}$/,
                                                    message:
                                                        "Enter valid 10 digit number",
                                                },
                                            }
                                        )}
                                    />

                                    {errors.mobileNumber && (
                                        <div className="invalid-feedback">
                                            {
                                                errors
                                                    .mobileNumber
                                                    .message
                                            }
                                        </div>
                                    )}

                                </div>

                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Account Type
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <Controller
                                        name="accountType"
                                        control={control}
                                        rules={{
                                            required: "Account Type is required",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                classNamePrefix="react-select"
                                                options={[
                                                    {
                                                        label: "B2B",
                                                        value: "B2B",
                                                    },
                                                    {
                                                        label: "B2C",
                                                        value: "B2C",
                                                    },
                                                    {
                                                        label: "BOTH",
                                                        value: "BOTH",
                                                    },
                                                ]}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}
                                            />
                                        )}
                                    />

                                    {errors.accountType && (
                                        <small className="text-danger">
                                            {errors.accountType.message}
                                        </small>
                                    )}

                                </div>

                                {/* COMPANY NAME */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Company Name
                                       
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.companyName
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Enter"
                                        {...register(
                                            "companyName",
                                            // {
                                            //     required:
                                            //         "Company Name is required",
                                            // }
                                        )}
                                    />
                                    {/* 
                                    {errors.companyName && (
                                        <div className="invalid-feedback">
                                            {
                                                errors.companyName
                                                    .message
                                            }
                                        </div>
                                    )} */}

                                </div>

                                {/* EMAIL */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Email ID
                                        <span className="text-danger ms-1">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="email"
                                        className={`form-control ${errors.emailId
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Enter email"
                                        {...register(
                                            "emailId",
                                            {
                                                required:
                                                    "Email is required",
                                            }
                                        )}
                                    />

                                    {errors.emailId && (
                                        <div className="invalid-feedback">
                                            {
                                                errors.emailId.message
                                            }
                                        </div>
                                    )}

                                </div>

                                {/* BUSINESS CATEGORY */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Business
                                        Category
                                    </label>

                                    <Controller
                                        name="businessCategory"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                // isMulti
                                                classNamePrefix="react-select"
                                                options={businessCategoryOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || []}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}

                                            />
                                        )}
                                    />

                                </div>

                                {/* SHIPPING */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Current
                                        Shipping Partner
                                    </label>

                                     <Controller
                                        name="currentShippingPartner"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                classNamePrefix="react-select"
                                                options={shippingPartnerOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || null}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}
                                            />
                                        )}
                                    />

                                </div>

                                {/* SHIPMENT */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Shipment
                                        Potential
                                    </label>

                                    <Controller
                                        name="shipmentPotential"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                // isMulti
                                                classNamePrefix="react-select"
                                                options={shipmentPotentialOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || []}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}

                                            />
                                        )}
                                    />

                                </div>

                                {/* MIN SHIPMENT */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Min. Expected
                                        Shipment to
                                        Fship
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "minimumExpectedShipmentToFship"
                                        )}
                                    />

                                </div>

                                {/* CLIENT PERSONA */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        Client Persona
                                    </label>

                                    <Controller
                                        name="clientPersona"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                // isMulti
                                                classNamePrefix="react-select"
                                                options={clientPersonaOptions}
                                                placeholder="Select"
                                                isClearable
                                                value={field.value || []}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}

                                            />
                                        )}
                                    />

                                </div>

                                {/* UTM SOURCE */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        UTM Source
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "utmSource"
                                        )}
                                    />

                                </div>

                                {/* UTM MEDIUM */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        UTM Medium
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "utmMedium"
                                        )}
                                    />

                                </div>

                                {/* UTM CAMPAIGN */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        UTM Campaign
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "utmCampaign"
                                        )}
                                    />

                                </div>

                                {/* UTM TERM */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        UTM Term
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "utmTerm"
                                        )}
                                    />

                                </div>

                                {/* UTM CONTENT */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        UTM Content
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter"
                                        {...register(
                                            "utmContent"
                                        )}
                                    />

                                </div>

                                {/* STATE */}
                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">
                                        State 
                                    </label>
                                    <Controller
                                        name="state"
                                        control={control}
                                        // rules={{
                                        //     required: "State is required",
                                        // }}
                                        render={({ field }) => (

                                            <Select
                                                {...field}
                                                classNamePrefix="react-select"
                                                placeholder="Select State"
                                                options={stateOptions}
                                                isClearable
                                                value={field.value || null}
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}
                                            />

                                        )}
                                    />

                                </div>

                            </div>
                            <div
                                className="d-flex justify-content-end gap-3 mt-5 pt-4"
                                style={{
                                    borderTop:
                                        "1px solid #f1f1f1",
                                }}
                            >

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={handleClose}
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                >
                                    Update Lead
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </div>

    );

});

export default EditB2BLeadModal;